<div
    class="tw-flex tw-justify-evenly sm:tw-p-6 tw-h-[100vh] tw-gap-5 sm:tw-bg-[#0A0A75] tw-bg-transparent tw-items-start sm:tw-items-center"
>
    <div
        class="tw-w-full sm:tw-w-[80%] lg:tw-w-[60%] tw-pt-4 tw-pb-10 xl:tw-w-[36%] tw-bg-white tw-rounded-[24px] tw-flex tw-flex-col tw-relative tw-z-[2]"
    >
        <header class="tw-text-center">
            <div
                class="tw-flex tw-justify-between tw-items-center tw-min-h-[4rem] tw-px-8 md:tw-px-10"
            >
                <div class="tw-flex-1"></div>
                <img
                    src="/assets/images/logo/header_desktop.webp"
                    alt="IMSME Logo"
                    class="tw-cursor-pointer tw-h-auto tw-w-[35%] tw-mx-auto"
                    [routerLink]="['/home']"
                />
                <div
                    class="tw-text-[16px] tw-font-medium tw-flex-1 tw-text-right"
                >
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('en')"
                        >{{ "LANG.EN" | translate }}</span
                    >
                    |
                    <span
                        class="tw-cursor-pointer"
                        (click)="switchLanguage('bm')"
                        >{{ "LANG.BM" | translate }}</span
                    >
                </div>
            </div>
        </header>
        <div class="tw-px-8 md:tw-px-16 tw-mt-2">
            <div
                class="tw-text-[24px] md:tw-text-[28px] tw-font-semibold tw-w-full"
            >
                {{ "COMMON.ENTER_THE_CODE" | translate }}
            </div>
            <div
                class="tw-text-[#7B7575] tw-mt-4 tw-font-medium tw-text-base tw-leading-6"
            >
                {{ "COMMON.SEND_TO" | translate }}
                <br class="tw-block sm:tw-hidden" />
                <span class="tw-inline sm:tw-inline">{{ userObj?.email || userObj?.username }}</span>
            </div>
        </div>
        <div
            class="tw-px-8 tw-mt-4 md:tw-px-16 tw-flex-1 tw-min-h-0 tw-flex tw-flex-col"
        >
            <form
                [formGroup]="confirmSignUpForm"
                (ngSubmit)="onConfirmDetails()"
                class="tw-h-full tw-flex tw-flex-col tw-relative"
            >
                <div class="tw-flex-1">
                    <input-general
                        class="tw-block tw-w-[100%] tw-rounded-2xl"
                        [placeHolder]="'*****'"
                        [hideInput]="true"
                        [controlName]="'confirmationCode'"
                        [errors]="
                            getErrors(
                                'confirmationCode',
                                'COMMON.CONFIRMATION_CODE' | translate
                            )
                        "
                    ></input-general>
                    <button
                        ga-event-id="confirm_next_button_rcp_click"
                        ga-event-category="Resend Code Page Button"
                        ga-event-label="Confirm and Next Button Click"
                        ga-track="track"
                        class="tw-mt-5 tw-rounded-[32px] tw-text-white tw-font-bold tw-h-[56px] tw-w-full tw-text-[16px]"
                        type="submit"
                        [disabled]="disableVerify"
                        [ngClass]="
                            (confirmSignUpForm.invalid || disableVerify)
                                ? 'tw-bg-[#FFA53C] tw-opacity-50'
                                : 'tw-bg-[#FFA53C]'
                        "
                    >
                        {{ "NEW_APPLICATION.VERIFY" | translate }}
                    </button>
                </div>

                <div class="tw-flex tw-flex-col tw-gap-4 tw-bg-white">
                    <div
                        class="tw-mt-6 tw-text-gray-400 tw-text-center"
                        *ngIf="showCountdown"
                    >
                        {{ "REGISTER.REQUEST_RESENT_CODE_MESSAGE" | translate }}
                        {{ countdown }}
                        {{ "COMMON.SECONDS" | translate }}
                    </div>
                    <div
                        class="tw-text-center tw-mt-6 access-btn tw-text-[#000000]"
                        *ngIf="!showCountdown"
                    >
                        <div class="tw-flex tw-justify-center req_new_code">
                            <mat-icon
                                class="error_outline_icon !tw-overflow-visible tw-mr-3"
                                >error_outline</mat-icon
                            >
                            <span>
                                {{ "COMMON.REQ_NEW_CODE" | translate }}</span
                            >
                        </div>
                        <div class="tw-mt-2">
                            <span
                                ga-event-id="resend_code_rcp_click"
                                ga-event-category="Resend Code Page Button"
                                ga-event-label="Resend Code Button Click"
                                ga-track="track"
                                class="tw-underline tw-pl-2"
                                (click)="onResendCode()"
                            >
                                {{ "COMMON.RESEND_A_NEW_CODE" | translate }}
                            </span>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <img
        class="tw-hidden sm:tw-block tw-absolute tw-left-0 tw-bottom-0"
        src="../../../../assets/images/login-signup/Blue-1.png"
        alt="Blue Img"
    />
</div>
